/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2023. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
/*
 *
 * Action types for SampleModule.
 *
 */

import { ReduxUtils } from '@spm/core';

const SET_USER_INPUT_TYPE = ReduxUtils.generateActionType(
  'chap-library',
  `PASSWORDRESETMODULE/SETUSERINPUT`,
  'SET'
);

const SET_USER_INPUT_VALIDATION_ERRORS_TYPE = ReduxUtils.generateActionType(
  'chap-library',
  `PASSWORDRESETMODULE/SETUSERINPUTVALIDATIONERRORS`,
  'SET'
);

export { SET_USER_INPUT_TYPE, SET_USER_INPUT_VALIDATION_ERRORS_TYPE };
